export const openDrawer = (selector) => {
    selector.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
};

export const closeDrawer = selector => {
    selector.classList.remove('is-open');
    document.documentElement.style.overflow = 'visible';
}

export const hideDrawerInit = () => {
    const buttonsElement = document.querySelectorAll('[data-drawer-selector="drawer-close"]');
    buttonsElement.forEach((button) => {
        const drawerElement = button.closest('[data-drawer-selector="drawer"]');
        if (drawerElement.getAttribute('data-drawer-initialized') !== 'true') {
            button.addEventListener('click', () => {
                closeDrawer(drawerElement)
            });

            drawerElement.addEventListener('click', (event) => {
                if (event.target === drawerElement) closeDrawer(drawerElement)
            });

            drawerElement.setAttribute('data-drawer-initialized', 'true');
        }
    });
};

hideDrawerInit();
